import { render, staticRenderFns } from "./GenValidateTypeList.vue?vue&type=template&id=16b94b0d&scoped=true"
var script = {}
import style0 from "./GenValidateTypeList.vue?vue&type=style&index=0&id=16b94b0d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b94b0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b94b0d')) {
      api.createRecord('16b94b0d', component.options)
    } else {
      api.reload('16b94b0d', component.options)
    }
    module.hot.accept("./GenValidateTypeList.vue?vue&type=template&id=16b94b0d&scoped=true", function () {
      api.rerender('16b94b0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/gen/GenValidateTypeList.vue"
export default component.exports